import * as actionTypes from './actionTypes';
import { apiFunction } from "../../apiCalls/functions"
import { ADMIN_LOGIN, LOGIN, SETTER_LOGIN, CHECKER_LOGIN, GET_PERMISSION } from "../../apiCalls/urls/login"
import { apiLoading, apiLoadingEnd } from "../notification/action";
import { actionNotifier } from "../../components/ui/toast";
import { navItems } from '../../container/layout/leftBar/json';
//AllAPIS
export const fetchLoginDetails = async (data) => {
    return await apiFunction(ADMIN_LOGIN, 'post', data, false, false)
}

export const fetchPermission = async (data) => {
    return await apiFunction(GET_PERMISSION, 'post', data, true, false)
}


export function onReloadAdmin() {
    return async (dispatch) => {
        dispatch(apiLoading())
        let result = await fetchPermission();
        if (result?.data?.code) {
            // The two endpoints disagree on shape. Login returns
            // { data, token, assignedSections } with the sections at the top
            // level, which is what localStorage and every reader expect.
            // /auth/permission goes through sendSuccess, so its whole body —
            // sections and tokens included — arrives nested under `data`.
            // Storing that verbatim left assignedSections one level too deep,
            // and the sidebar and route filter both read it as empty, blanking
            // the menu for the signed-in admin.
            const payload = result.data.data || {};
            const { assignedSections, token, refreshToken, expiresIn, ...user } = payload;

            const session = {
                ...result.data,
                data: user,
                token: token ?? result.data.token,
                refreshToken: refreshToken ?? result.data.refreshToken,
                expiresIn: expiresIn ?? result.data.expiresIn,
                assignedSections: assignedSections || [],
            };

            localStorage.setItem("bor-admin-login-data", JSON.stringify(session))
            dispatch(updateLoginDetails(session))
        }
        else {
            console.log(result.message)
        }
        dispatch(apiLoadingEnd())
    }
}

export function onLogin(email, password, captchaToken, navigate, showCaptcha) {
    return async (dispatch) => {
        dispatch(apiLoading())
        let data = {
            "user_name": email,
            "password": password,
            captcha_token:captchaToken
        }
        let result = await fetchLoginDetails(data);
        console.log(result);
        if (result?.data?.code) {
            localStorage.setItem("bor-admin-login-data", JSON.stringify(result.data))
            dispatch(updateLoginDetails(result.data))
            if (result.data.data.user_type === 'ATTENDANCE') {
                navigate('/view-exams');
            } else {
                navigate('/report');

            }
        }
        else {
            if(result?.requiresCaptcha)
                showCaptcha();
            actionNotifier.error(result?.message)
        }
        dispatch(apiLoadingEnd())
    }
}

export const onLogout = (navigate) => {
    return async (dispatch) => {
        localStorage.removeItem("bor-admin-login-data")
        dispatch(updateLoginDetails([]))
        navigate("/")
    }
}


// ACTIONS
export const updateLoginDetails = (data) => {
    return {
        type: actionTypes.UPDATE_LOGIN_DETAILS,
        payload: { data }
    };
}

export const importAdminDataFromLocal = () => {
    return (dispatch) => {
        let data = localStorage.getItem("bor-admin-login-data")
        // console.log(data)
        if (data) {
            data = JSON.parse(data)

            dispatch(updateLoginDetails(data))
        }
    }
}